<template>
  <a-card>
    <!-- <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane key="1" tab="工作经历">
        
      </a-tab-pane>
      <a-tab-pane key="2" tab="教育经历">
      </a-tab-pane>
      <a-tab-pane key="3" tab="项目经验">
      </a-tab-pane>
    </a-tabs> -->
    <h4>工作经历</h4>
    <workExprise />
    <h4>教育经历</h4>
    <eduExprise />
    <h4>项目经验</h4>
    <projectExprise/>

  </a-card>
</template>

<script>
import workExprise from './workExprise';
import eduExprise from './eduExprise';
import projectExprise from './projectExprise';
export default {
  name: "index",
  components: {
    workExprise, eduExprise, projectExprise
  },
  data() {
    return {
      activeKey: '1'
    }
  },
  methods: {

  }
}
</script>

<style scoped></style>
